import { Lock } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Card } from "@/components/ui/card"
import type { OT } from "@/features/transit/api/types"

// Slim banner shown on every per-stage panel once the OT is archived.
// Communicates the read-only state and the completion timestamp so the
// user never wonders why inputs are disabled.
export function LockedBanner({ ot }: { ot: OT }) {
  const { t, i18n } = useTranslation("transit")
  const completedAt = formatDate(ot.completedAt, i18n.language)

  return (
    <Card className="bg-muted/40 flex items-start gap-3 px-4 py-3">
      <div className="bg-muted text-muted-foreground flex size-8 flex-shrink-0 items-center justify-center rounded-full">
        <Lock className="size-4" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-foreground text-sm font-medium">
          {t("locked.title")}
        </div>
        <p className="text-muted-foreground text-xs">
          {completedAt
            ? t("locked.bodyWithDate", { at: completedAt })
            : t("locked.body")}
        </p>
      </div>
    </Card>
  )
}

function formatDate(value: string | null | undefined, locale: string) {
  if (!value) return null
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return null
  try {
    return d.toLocaleDateString(locale, { dateStyle: "long" })
  } catch {
    return d.toISOString().slice(0, 10)
  }
}
